import React, { Component } from 'react';
// import Modal from "../../../../../shared/modal";
import Modal from 'react-responsive-modal';
const closeSvg = <path d="M28.5 9.62L26.38 7.5 18 15.88 9.62 7.5 7.5 9.62 15.88 18 7.5 26.38l2.12 2.12L18 20.12l8.38 8.38 2.12-2.12L20.12 18z" />
const ModalMoreReasons = ({ open = false, handleClose, reasonsDerivations = [] }) => {
	return(
		<Modal open={open} onClose={handleClose} closeIconSvgPath={closeSvg} center={true}>
			<div className="col-md-12">
				<span className="h2 m20 ml10 mb10">Inspección Observada</span>
				<div className="text-md--light m10">
					La inspección fue observada por los siguientes motivos:
				</div>
				<div className="row mt10">
					<div className="col-md-12">
						{
							reasonsDerivations && reasonsDerivations.map((reason, index) => (
									<div className="reasons-modal" key={index}>
                                        <img src='./images/icn_atencion2.svg' />
                                        <span className="text-red">{reason.label}</span>
                                    </div>
							))
						}
					</div>
				</div>
			</div>
			
		</Modal>
	);
}
export default ModalMoreReasons;



// WEBPACK FOOTER //
// ./src/components/app/dashboard/inspection/components/moreReasons/modal-more-reasons.js